import { Button, Grid, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import CustomButton from "../Button/CustomButton";
import { currentCurrency } from "../../features/currencySlice";
import { useSelector } from "react-redux";
import numeral from "numeral";

const useStyles = makeStyles({
  container: {
    background:
      "linear-gradient( 143.3deg,  rgba(216,27,96,1) 33.1%, rgba(237,107,154,1) 74.9% ) !important",
    margin: "25px 0",
    color: "#FFF",
    padding: "15px 0px",
  },
  items: {
    marginRight: "24px",
  },
});

function ExchangeSingleMarketHeader({ data }) {
  const classes = useStyles();

  const currentCurSelected = useSelector(currentCurrency);
  console.log(data);
  return (
    <Grid container className={classes.container}>
      <Grid item xs={4} alignContent>
        <Typography variant={"h3"} align={"center"}>
          {data?.name}
        </Typography>
      </Grid>
      <Grid container xs={8} justify={"center"}>
        <Grid item className={classes.items} align={"center"}>
          <Typography variant={"h5"}>Pairs</Typography>
          <Typography variant={"h5"}>
            {numeral(data?.tradingPairs).format("0,0")}
          </Typography>
        </Grid>
        <Grid item className={classes.items} align={"center"}>
          <Typography variant={"h5"}>Volume (24Hr)</Typography>
          <Typography>
            {(currentCurSelected.currencySymbol !== null
              ? currentCurSelected.currencySymbol
              : "") +
              numeral(
                parseFloat(data?.volumeUsd) / currentCurSelected.rateUsd
              ).format("0,0")}
          </Typography>
        </Grid>

        <Grid item className={classes.items} align={"center"}>
          <a
            target={"_blank"}
            href={data?.exchangeUrl}
            style={{ textDecoration: "none" }}
          >
            <CustomButton text={"Website"} />
          </a>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ExchangeSingleMarketHeader;
